import { render, staticRenderFns } from "./detail-component-validation-request.vue?vue&type=template&id=673d5e15&scoped=true"
import script from "./detail-component-validation-request.vue?vue&type=script&lang=ts"
export * from "./detail-component-validation-request.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673d5e15",
  null
  
)

export default component.exports